import { useEffect, useState } from 'react'

import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'

import './index.scss'

import letter_a from '../../assets/images/name/a.png';
import letter_k from '../../assets/images/name/k.png';
import letter_s from '../../assets/images/name/s.png';
import letter_h from '../../assets/images/name/h.png';
import letter_t from '../../assets/images/name/t.png';
import letter_u from '../../assets/images/name/u.png';
import letter_l from '../../assets/images/name/l.png';

const About = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  useEffect(() => {
    setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)
  }, [])

  return (
    <>
      <div className="container about-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['A', 'b', 'o', 'u', 't', ' ', 'm', 'e']}
              idx={15}
            />
          </h1>
          <div className='info-box'>
            
            <p>
            I am a creative, ambitious and tech-oriented person with a clear goal. 
            Also, being reliable and motivated, I am able to adapt myself to 
            different kinds of environments and provide a positive impact. 
            I love solving new problems and have equipped myself with the necessary skills that 
            are required to solve them.
            </p>

            <p>
            Currently, in the final year of my undergraduate degree 
            @<a href="https://www.iiitb.ac.in/" target="_blank" rel="noreferrer">IIIT Bangalore</a>, 
            I have both personal and professional experience in the field of software development.
            </p>

            <p>
              I love learning new stuff which is mostly technical but is not limited to it. 
              I also love playing football and badminton and I am a huge fan of fitness. In my free time, 
              I like to read and write stuff.<br />
              If you find something interesting about me, drop a message and let's catch up.
            </p>

            <br />
            <p>
              P.S. Here are some of the technical skills I possess
            </p>

          </div>


        </div>
        <div className="skillset-box">

            <div className="skill-box">
              <i>Java</i>
            </div>
            <div className="skill-box">
              <i>C++</i>
            </div>
            <div className="skill-box">
              <i>Python3</i>
            </div>
            <div className="skill-box">
              <i>OOP</i>
            </div>
            <div className="skill-box">
              <i>Data Structures</i>
            </div>
            <div className="skill-box">
              <i>Algorithms</i>
            </div>
            <div className="skill-box">
              <i>DBMS</i>
            </div>
            <div className="skill-box">
              <i>SQL</i>
            </div>
            <div className="skill-box">
              <i>CI/CD</i>
            </div>
            <div className="skill-box">
              <i>Springboot</i>
            </div>
            <div className="skill-box">
              <i>Maven</i>
            </div>
            <div className="skill-box">
              <i>Docker</i>
            </div>
            <div className="skill-box">
              <i>Angular JS</i>
            </div>
            <div className="skill-box">
              <i>React JS</i>
            </div>
            <div className="skill-box">
              <i>Flutter</i>
            </div>
            <div className="skill-box">
              <i>Git/Github</i>
            </div>
            <div className="skill-box">
              <i>Jenkins</i>
            </div>
            <div className="skill-box">
              <i>Ansible</i>
            </div>


          </div>

        <div className="name-anim">
                
                {/* <img src={akshath} alt="Akshath" /> */}
                
                <div className="first-name">
                    <img src={letter_a} alt="letter" />
                    <img src={letter_k} alt="letter" />
                    <img src={letter_s} alt="letter" />
                    <img src={letter_h} alt="letter" />
                    <img src={letter_a} alt="letter" />
                    <img src={letter_t} alt="letter" />
                    <img src={letter_h} alt="letter" />
                </div>
                <div className="last-name">
                    <img src={letter_k} alt="letter" />
                    <img src={letter_a} alt="letter" />
                    <img src={letter_u} alt="letter" />
                    <img src={letter_s} alt="letter" />
                    <img src={letter_h} alt="letter" />
                    <img src={letter_a} alt="letter" />
                    <img src={letter_l} alt="letter" />
                </div>

                
            </div>
        

      </div>
      <Loader type="pacman" />
    </>
  )
}

export default About